(function () {
    'use strict';

    angular
        .module('app.soloutils', []);
})();

(function () {
    'use strict';

    angular
        .module('app.soloutils')
        .filter('nl2br', nl2br);

    /* @ngInject */
    function nl2br() {
        return function (input) {
            if (input) {
                return input.replace(/\n/g, '<br>');
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.soloutils')
        .filter('htmlToText', htmlToText);

    /* @ngInject */
    function htmlToText() {
        return function (text) {
            return text ? String(text).replace(/<[^>]+>/gm, '') : '';
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.soloutils')
        .directive('isScrolled', MediaDirective);

    /* @ngInject */
    function MediaDirective($document) {
        return function (scope, element, attrs) {
            var mainContent = $document[0].getElementById('viewport');
            mainContent.onscroll = function () {
                if (mainContent.scrollTop == 0) {
                    angular.element($document[0].body).addClass('scrolled-top');
                } else {
                    angular.element($document[0].body).removeClass('scrolled-top');
                }
            };

            scope.$on("$destroy", function () {
                mainContent.onscroll = null;
            });
        };
    }
})();

(function (angular) {
    'use strict';

    angular.module('app.soloutils').config(Config);

    /* @ngInject */
    function Config($provide) {

        $provide.decorator('ngModelDirective', function ($delegate) {
            var directive = $delegate[0];
            var shouldSetBlurUpdateEvent = function (nodeName, inputType) {
                // The blur event is only really applicable to input controls so
                // we want to stick with the default events for selects, checkboxes & radio buttons
                return nodeName.toLowerCase() === 'textarea' ||
                    (nodeName.toLowerCase() === 'input' &&
                    inputType.toLowerCase() !== 'checkbox' &&
                    inputType.toLowerCase() !== 'radio');
            };

            // save a reference to the original compile function
            var compileFn = directive.compile;

            directive.compile = function () {

                var link = compileFn.apply(this, arguments);

                return {
                    pre: function ngModelPostLink(scope, element, attr, ctrls) {
                        if (angular.isDefined(attr.autoSave)) {
                            if (!ctrls[2]) {
                                ctrls[2] = {};
                            }

                            var ngModelOptions = ctrls[2];

                            if (angular.isUndefined(ngModelOptions.$options) && shouldSetBlurUpdateEvent(element[0].nodeName, element[0].type)) {
                                ngModelOptions.$options = {
                                    updateOn: 'default blur',
                                    debounce: {'default': 1000, 'blur': 0},
                                    updateOnDefault: true
                                };
                            }
                        }

                        link.pre.apply(this, arguments);
                    },
                    post: link.post
                };
            };

            return $delegate;
        });

    }

}(angular));

(function () {
    'use strict';

    angular
    .module('app.tables', [
        'restmod',
        'restmod.styles.drfPaged'
    ])
    .constant('AppSettings', {
        appName: 'Solo',
        apiUrl: 'https://api.prospector.solo.com.pt',
        mediaUrl: 'https://api.prospector.solo.com.pt/static/media'
    });
})();

(function () {
    'use strict';

    angular
        .module('app.tables')
        .factory('ProposalsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        return restmod.model('/proposals').mix('MixinContainable', {
            $config: {
                contains: {
                    services: {
                        type: 'hasMany',
                        table: 'ProposalServicesTable',
                        foreignKey: 'proposal'
                    },
                    sections: {
                        type: 'hasMany',
                        table: 'ProposalSectionsTable',
                        foreignKey: 'proposal'
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
    .module('app.tables')
    .factory('ProposalServicesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory (restmod) {
        return restmod.model('/proposal-services').mix('MixinContainable', {});
    }
})();

(function () {
    'use strict';

    angular
    .module('app.tables')
    .factory('ProposalSectionsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory (restmod) {
        return restmod.model('/proposal-sections').mix('MixinContainable', {
            $config: {
                contains: {
                    contents: {
                        type: 'hasMany',
                        table: 'ProposalSectionContentsTable',
                        foreignKey: 'section'
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
    .module('app.tables')
    .factory('ProposalSectionContentsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory (restmod) {
        return restmod.model('/proposal-section-contents').mix('MixinContainable', {
            $config: {
                contains: {
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.tables')
        .factory('ProposalFilesTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        return restmod.model('/proposal-files').mix('MixinContainable', {});
    }
})();

(function () {
    'use strict';

    angular
        .module('app.tables')
        .factory('MixinContainable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod, $injector) {

        function recordLoad(record, key, config, additionalFilters) {
            additionalFilters = additionalFilters || {};

            function recordLoadBelongsTo(table) {
                record['$' + key] = table.$new();
                record.$then(function () {
                    record['$' + key].$pk = record[config.foreignKey];
                    record['$' + key].$fetch();
                });
            }

            function recordLoadHasMany(table) {
                record['$' + key] = table.$collection(additionalFilters);
                record.$then(function () {
                    record['$' + key].$params[config.foreignKey] = record.$pk;
                    record['$' + key].$fetch();
                });
            }

            var loader = false;
            switch (config.type) {
                case 'belongsTo':
                    loader = recordLoadBelongsTo;
                    break;
                case 'hasMany':
                    loader = recordLoadHasMany;
                    break;
                default:
                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            loader.$inject = [config.table];
            $injector.invoke(loader);

            return record;
        }

        function collectionLoad(collection, key, config, additionalFilters) {
            additionalFilters = additionalFilters || {};

            function collectionLoadBelongsTo(table) {
                collection.$then(function () {
                    var keys = collection.map(function (obj) {
                        return obj[config.foreignKey];
                    });

                    var request = table.$search({
                        'id__in': keys.join(',')
                    }).$then(function (data) {
                        var objsById = {};
                        angular.forEach(data, function (respObj) {
                            objsById[respObj.$pk] = respObj;
                        });

                        angular.forEach(collection, function (item) {
                            item['$' + key] = objsById[item[config.foreignKey]];
                        });
                    });
                    angular.forEach(collection, function (item) {
                        item['$' + key] = request;
                    });
                    collection['$' + key] = request;
                });
            }

            function collectionLoadHasMany(table) {
                var fieldName = config.foreignKey;
                collection['$' + key] = table.$collection(additionalFilters);
                collection.$then(function () {
                    collection['$' + key].$params[fieldName] = collection.$pk;
                    collection['$' + key].$fetch();
                });
            }

            var loader = false;
            switch (config.type) {
                case 'belongsTo':
                    loader = collectionLoadBelongsTo;
                    break;
                case 'hasMany':
                    loader = collectionLoadHasMany;
                    break;
                default:
                    throw new Error('Unknown contain type "' + config.type + '" for MixinContainable');
            }

            loader.$inject = [config.table];
            $injector.invoke(loader);

            return collection;
        }

        function getModelConfigs(model, relatedModel) {
            var contains = model.$type.getProperty('contains');
            if (contains && contains[relatedModel]) {
                var config = angular.copy(contains[relatedModel]);
                config['filters'] = config['filters'] || {};
                return config;
            } else {
                throw new Error('Cannot find MixinContainable configs for ' + model);
            }
        }

        return restmod.mixin({
            $extend: {
                Collection: {
                    $load: function (relatedModel, additionalFilters) {
                        var configs = getModelConfigs(this, relatedModel);
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        return collectionLoad(this, relatedModel, configs, additionalFilters);
                    }
                },
                Record: {
                    $load: function (relatedModel, additionalFilters) {
                        var configs = getModelConfigs(this, relatedModel);
                        additionalFilters = angular.extend(configs.filters, additionalFilters);
                        return recordLoad(this, relatedModel, configs, additionalFilters);
                    }
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
    .module('app.tables')
    .factory('ContactsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory (restmod, AppSettings) {
        return restmod.model('/contacts').mix('MixinContainable', {
            $config: {
                urlPrefix: AppSettings.contactsApiUrl
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.tables')
        .config(Config);

    /* @ngInject */
    function Config(restmodProvider, AppSettings) {
        restmodProvider.rebase({
            $config: {
                urlPrefix: AppSettings.apiUrl
            }
        });
        restmodProvider.rebase('DjangoDRFPagedApi');
    }
})();

(function () {
    'use strict';

    angular
    .module('app', [
        'ngAnimate',
        'ngSanitize',
        'ngAria',
        'ui.router',
        'ngMaterial',
        'restmod',
        'cgBusy',
        'ngFileUpload',
        'app.tables',
        'app.notfound',
        'app.soloutils',
        'app.media',
        'app.main',
        'angularTypewrite',
        'duScroll',
        'angularMoment',
        'viewhead',
        'angulartics',
        'angulartics.google.analytics'
    ]);

})();

angular.module('app').directive("proposalScroll", function ($window) {
    return function (scope, element, attrs) {
        angular.element(element).bind("scroll", function (ev) {
            var target = ev.target;
            var value = Math.min(target.scrollTop, target.clientHeight);
            target.style.paddingTop = value + 'px';
            scope.$apply();
        });
    };
});

(function () {
    'use strict';

    angular
        .module('app.main', []);
})();

(function () {
    'use strict';

    angular
    .module('app.main')
    .run(appRun);

    /* @ngInject */
    function appRun (routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates () {
        return [
            {
                state: 'home',
                config: {
                    url: '/',
                    templateUrl: 'app/main/views/main.home.html',
                    controller: 'PagesBasicController',
                    controllerAs: 'vm'
                }
            },
            {
                state: 'proposal',
                config: {
                    url: '/:id',
                    templateUrl: 'app/main/views/main.proposal.html',
                    controller: 'MainProposalController',
                    controllerAs: 'vm',
                    resolve: {
                        /* @ngInject */
                        proposal: function (ProposalsTable, $stateParams, $state) {
                            return ProposalsTable.$find($stateParams.id).$then(function (proposal) {
                                return proposal;
                            }, function () {
                                //$state.go('home');
                            }).$promise;
                        }
                    }
                }
            }
        ];
    }

})();

(function () {
    'use strict';

    angular
        .module('app.main')
        .controller('MainProposalController', Controller);

    /* @ngInject */
    function Controller(proposal, ProposalFilesTable, ProposalServicesTable, ProposalSectionsTable, ProposalSectionContentsTable) {
        var vm = this;
        vm.proposal = proposal;
        vm.proposal.$pk = vm.proposal.id;

        activate();

        function activate() {
            vm.proposal.$services = ProposalServicesTable.$search({proposal__slug: vm.proposal.slug});
            vm.proposal.$sections = ProposalSectionsTable.$search({proposal__slug: vm.proposal.slug});
            vm.proposal.$files = ProposalFilesTable.$search({proposal__slug: vm.proposal.slug, comment__isnull: 'True'});
            vm.proposal.$sections.$then(function () {
                vm.proposal.$sections.forEach(function (sections) {
                    sections.$load('contents');
                    sections.$contents = ProposalSectionContentsTable.$search({section__proposal__slug: vm.proposal.slug});
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.main')
        .service('NewsletterService', service);

    /* @ngInject */
    function service($http, AppSettings) {
        this.subscribe = function (email) {
            return $http.post(AppSettings.contactsApiUrl + '/newsletter/subscribe/', {
                email: email
            });
        };

        this.unsubscribe = function (email) {
            return $http.post(AppSettings.contactsApiUrl + '/newsletter/unsubscribe/', {
                email: email
            });
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.main')
        .controller('PagesBasicController', Controller);

    /* @ngInject */
    function Controller(NewsletterService, ContactsTable, $mdToast) {
        var vm = this;

        vm.subscribeNewsletter = subscribeNewsletter;
        vm.openSubscription = true;


        vm.sendContact = sendContact;
        vm.contact = ContactsTable.$build();


        activate();

        function activate() {
        }

        function subscribeNewsletter() {
            NewsletterService.subscribe(vm.newsletter.email)
                .then(function (success) {
                    vm.openSubscription = false;
                    vm.newsletter.success = success;
                }, function (error) {
                    vm.newsletter.error = error;
                });
        }

        function sendContact() {
            vm.contact.subject = 'Contacto de ' + vm.contact.name + ' no site da Solo';
            vm.contact.$save().$then(function () {
                vm.contact = ContactsTable.$build();
                $mdToast.show($mdToast.simple().textContent('Obrigado pelo teu contacto!'));
            });
            vm.contactActive = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.notfound', []);
})();

(function () {
    'use strict';

    angular
        .module('app.notfound')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope) {
        $rootScope.notfoundStateChangeError = $rootScope.$on('$stateChangeError', function (e) {
            $state.go('notfound');
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.notfound')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'notfound',
                config: {
                    templateUrl: 'app/notfound/views/notfound.html',
                    controller: 'NotFoundController',
                    controllerAs: 'vm',
                    url: '/notfound'
                }
            }
        ];
    }

})();

(function () {
    'use strict';

    angular
        .module('app.notfound')
        .controller('NotFoundController', Controller);

    /* @ngInject */
    function Controller() {
        var vm = this;


        activate();

        function activate() {
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.tables')
        .factory('MediaTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {

        return restmod.model('/media').mix('MixinContainable', {});
    }
})();

(function() {
    'use strict';

    angular
        .module('app.media', []);
})();

(function () {
    'use strict';

    angular
    .module('app.media')
    .service('MediaService', Service);

    /* @ngInject */
    function Service (Upload, AppSettings, $mdToast) {
        this.upload = upload;

        function upload (file) {
            $mdToast.show($mdToast.simple().textContent('Uploading ...'));

            if (file) {
                return Upload.upload({
                    url: AppSettings.apiUrl + '/media/',
                    data: {
                        'file': file
                    }
                }).then(function (data) {
                    return data.data.file;
                }, function () {
                    $mdToast.updateTextContent('An error has ocurred');
                    return undefined;
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    $mdToast.updateTextContent('Uploading (' + progressPercentage + '%)');
                });
            } else {
                $mdToast.updateTextContent('Invalid file!');
                return undefined;
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.media')
        .run(runBlock);

    /* @ngInject */
    function runBlock($rootScope, MediaService) {
        $rootScope.$Media = MediaService;
    }

})();
(function () {
    'use strict';

    angular
        .module('app.media')
        .filter('mediaUrl', MediaUrl);

    /* @ngInject */
    function MediaUrl(AppSettings) {
        return function (input) {
            if (input) {
                return AppSettings.mediaUrl + '/' + input;
            } else {
                return null;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.media')
        .directive('mediaAutoUpload', MediaDirective);

    /* @ngInject */
    function MediaDirective($parse) {
        return {
            require: '?ngModel',
            link: function (scope, element, attributes) {
                var getter = $parse(attributes.ngModel);
                var setter = getter.assign;
                var $scope = scope;

                var contentType = attributes.mediaContentType;
                var objectId = attributes.mediaObjectId;

                $scope.$watch(attributes.ngModel, function () {
                    var file = getter($scope);
                    if (
                        file &&
                        typeof file == 'object' &&
                        (file instanceof File || file instanceof Blob)
                    ) {
                        var promise = $scope.$Media.upload(file, contentType, objectId);
                        setter($scope, promise);
                        promise.then(function (data) {
                            setter($scope, data);
                        }, function (data) {
                            setter($scope, data);
                        });
                    }
                });
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.main')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'blank',
                config: {
                    url: '/',
                    templateUrl: '<ui-view flex layout="column" id="blank-layout"></ui-view>',
                    controller: 'PagesBasicController'
                }
            }
        ];
    }

})();

//! moment.js locale configuration
//! locale : portuguese (pt)
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        ordinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

}));
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "AM",
      "PM"
    ],
    "DAY": [
      "domingo",
      "segunda-feira",
      "ter\u00e7a-feira",
      "quarta-feira",
      "quinta-feira",
      "sexta-feira",
      "s\u00e1bado"
    ],
    "ERANAMES": [
      "Antes de Cristo",
      "Ano do Senhor"
    ],
    "ERAS": [
      "a.C.",
      "d.C."
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "janeiro",
      "fevereiro",
      "mar\u00e7o",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "SHORTDAY": [
      "dom",
      "seg",
      "ter",
      "qua",
      "qui",
      "sex",
      "s\u00e1b"
    ],
    "SHORTMONTH": [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez"
    ],
    "STANDALONEMONTH": [
      "janeiro",
      "fevereiro",
      "mar\u00e7o",
      "abril",
      "maio",
      "junho",
      "julho",
      "agosto",
      "setembro",
      "outubro",
      "novembro",
      "dezembro"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "EEEE, d 'de' MMMM 'de' y",
    "longDate": "d 'de' MMMM 'de' y",
    "medium": "d 'de' MMM 'de' y HH:mm:ss",
    "mediumDate": "d 'de' MMM 'de' y",
    "mediumTime": "HH:mm:ss",
    "short": "dd/MM/yy HH:mm",
    "shortDate": "dd/MM/yy",
    "shortTime": "HH:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "R$",
    "DECIMAL_SEP": ",",
    "GROUP_SEP": ".",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "pt",
  "localeID": "pt",
  "pluralCat": function(n, opt_precision) {  if (n >= 0 && n <= 2 && n != 2) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
});
}]);

(function () {
    'use strict';

    angular
        .module('app')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $anchorScroll, amMoment) {

        $rootScope.pageLoading = false;
        $rootScope.stateChangeStartCloseMenu = $rootScope.$on('$stateChangeStart', function (event, toState) {
            $rootScope.pageLoading = true;
        });

        $rootScope.stateChangeStartCloseMenu = $rootScope.$on('$stateChangeSuccess', function () {
            $rootScope.pageLoading = false;
            $anchorScroll('top');
        });

        amMoment.changeLocale('pt');
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig)
        .provider('routerHelper', routerHelperProvider);


    /** @ngInject */
    function routerConfig($urlRouterProvider) {
        $urlRouterProvider.otherwise('/');
    };


    /* @ngInject */
    function routerHelperProvider($stateProvider,
                                  $urlRouterProvider,
                                  $urlMatcherFactoryProvider,
                                  $locationProvider) {

        /* jshint validthis:true */
        this.$get = RouterHelper;

        // enabling the html5Mode will get rid of the urls with
        // the fragment hash, so we go from the ugly http://www.domain.com/#/list
        // to the nicer http://www.domain.com/list
        // for more information: https://docs.angularjs.org/api/ng/provider/$locationProvider
        $locationProvider.html5Mode(true);
        $urlMatcherFactoryProvider.strictMode(false);

        /* @ngInject */
        function RouterHelper($state) {
            var hasOtherwise = false;

            var service = {
                configureStates: configureStates,
                getStates: getStates
            };

            return service;

            ///////////////

            function configureStates(states, otherwisePath) {

                states.forEach(function (state) {
                    $stateProvider.state(state.state, state.config);
                });

                if (otherwisePath && !hasOtherwise) {
                    hasOtherwise = true;
                    $urlRouterProvider.otherwise(otherwisePath);
                }
            }

            function getStates() {
                return $state.get();
            }
        }
    }

})();

/* global malarkey:false, moment:false */
(function () {
    'use strict';

    angular
        .module('app');

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(config)
        .value('cgBusyDefaults', {
            message: '',
            templateUrl: 'app/components/cgbusy/cgbusy.template.html'
        });

    /** @ngInject */
    function config($mdThemingProvider) {
        $mdThemingProvider.definePalette('black', {
            '50': 'ffebee',
            '100': 'ffcdd2',
            '200': 'ef9a9a',
            '300': 'e57373',
            '400': '000000',
            '500': 'f44336',
            '600': 'e53935',
            '700': 'd32f2f',
            '800': 'c62828',
            '900': 'b71c1c',
            'A100': 'ff8a80',
            'A200': 'ff5252',
            'A400': 'ff1744',
            'A700': 'd50000',
            'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                                // on this palette should be dark or light

            'contrastDarkColors': undefined,
            'contrastLightColors': undefined    // could also specify this if default was 'dark'
        });

        $mdThemingProvider.theme('default')
            .primaryPalette('black', {
                'default': '400'
            })
            .accentPalette('deep-orange');

    }

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/cgbusy/cgbusy.template.html","<div class=cg-busy-processing-wrapper layout=row layout-align=\"center center\"><span>{{$message}}</span><md-progress-circular md-mode=indeterminate></md-progress-circular></div><style>.cg-busy-processing-wrapper{\n        position: relative;\n        width: 100%;\n        height: 100%;\n    }</style>");
$templateCache.put("app/main/views/main.home.html","<md-content proposal-scroll id=proposal-md-content flex style=\"background-color: transparent\"><div id=proposal-cover layout=column layout-align=\"center center\"><img src=assets/images/solo.png><h1>Solo, Lda</h1><h3 style=\"font-size: 34px\"><span view-title>Propostas</span></h3></div></md-content><style>body {\n     background-color: #F9F9F9 !important;\n }\n\n #viewport {\n     background: transparent;\n }</style>");
$templateCache.put("app/main/views/main.proposal.html","<md-content proposal-scroll id=proposal-md-content flex style=\"background-color: transparent\"><div id=proposal-cover layout=column layout-align=\"center center\" style=\"background-color: #{{::vm.proposal.mainColor}}\"><img src=assets/images/solo.png><h1 view-title>{{::vm.proposal.name}}</h1><h3><span>{{::vm.proposal.date | amDateFormat:\'DD [de] MMMM [de] YYYY\'}}</span></h3><div layout=row layout-align=\"space-around center\" class=jump-btns><a href=#proposal-description class=\"md-button site-only\" analytics-on=click analytics-event=\"Jump to proposal\">Proposta</a> <a href=#pricing class=\"md-button site-only\" analytics-on=click analytics-event=\"Jump to pricing\">Orçamento</a></div><div id=proposal-info><b>Versão {{::vm.proposal.version}}</b><div>{{::vm.proposal.authors}}</div><div>{{::vm.proposal.writers}}</div><div ng-if=vm.proposal.expirationDate>Válido até {{::vm.proposal.expirationDate | amDateFormat:\'DD [de] MMMM [de] YYYY\'}}</div></div></div><div class=\"site-only page-image-header-extension\" style=\"background-image: url(\'assets/images/boxes.jpg\')\"></div><div class=page><div class=page-image-header style=\"background-image: url(\'assets/images/boxes.jpg\')\"><h1>Proposta</h1></div><div class=page-content id=proposal-description><div layout=row><div class=text-columns-2 ng-bind-html=\"vm.proposal.description | nl2br\"></div></div></div></div><div ng-repeat-start=\"section in vm.proposal.$sections | orderBy:\'order\'\" class=\"site-only page-image-header-extension\" style=\"background-image: url(\'{{section.cover | mediaUrl}}\')\"></div><div class=page ng-repeat-end><div class=page-image-header style=\"background-image: url(\'{{section.cover | mediaUrl}}\')\"><h1>{{::section.name}}</h1></div><div class=page-content><div layout=row><div class=text-columns-2><h5 ng-repeat-start=\"content in section.$contents | orderBy:\'order\'\">{{::content.name}}</h5><p ng-repeat-end ng-bind-html=\"content.description | nl2br\"></p></div></div></div></div><div class=\"site-only page-image-header-extension\" style=\"background-image: url(\'assets/images/orcamento.jpg\')\"></div><div class=page id=pricing><div class=page-image-header style=\"background-image: url(\'assets/images/orcamento.jpg\')\"><h1>Orçamento</h1></div><div class=page-content><table class=pricing-table><tr><th align=left>Serviço</th><th>Custo</th><th align=left>Observações</th></tr><tr ng-repeat=\"service in vm.proposal.$services | orderBy:\'order\'\"><td>{{::service.name}}</td><td align=center>{{::service.price}}€</td><td>{{::service.notes}}</td></tr><tr><th align=left>Total</th><th align=center>{{::vm.proposal.totalPrice}}€</th><th></th></tr></table><small class=msg>Acresce o valor do IVA à taxa em vigor. </small><small class=msg>{{::vm.proposal.aboutPayments}}</small></div></div><div class=\"site-only page-image-header-extension\" style=\"background-image: url(\'assets/images/landing-back.jpg\')\"></div><div class=page><div class=page-image-header style=\"background-image: url(\'assets/images/landing-back.jpg\')\"><h1>Sobre a Solo</h1></div><div class=page-content><div layout=row><div class=text-columns-2><p>A Solo é uma empresa de desenvolvimento de software à medida. Desenvolve projetos com recursos a tecnologias web, mobile e interatividade.</p><p>Sendo uma empresa de base e vocação tecnológica a Solo não nega o gosto pelas melhores ferramentas digitais e pelo desafio de um mercado em constante evolução.</p><p>Não obstante, a razão de ser da Solo é a realização de projetos que tenham impacto real no dia-a-dia de empresas e profissionais.</p><p>Este desígnio transparece no compromisso de pensar e executaros projetos de forma a trazer sempre valor acrescentado aos nossos clientes, tendo como crucial o envolvimento destes em todas as etapas dos mesmos.</p><p>Em tudo em que se envolve a Solo valoriza a qualidade, que só é possível através de processos claros, simples e sólidos.</p><h5>Contactos</h5><p>Solo, Lda<br>Rua Dr. Paulo Pombo, 82 12º Sala 2<br>4250-363 Porto<br></p><p><a href=mailto:ola@solo.com.pt>ola@solo.com.pt</a><br><a href=phone:926758648>92 675 86 48</a><br><a href=https://www.solo.com.pt>www.solo.com.pt</a></p></div></div></div></div><div ng-if=vm.proposal.$files.length class=\"site-only page-image-header-extension\" style=\"background-image: url(\'assets/images/attachments.jpg\')\"></div><div ng-if=vm.proposal.$files.length class=page id=attachments><div class=page-image-header style=\"background-image: url(\'assets/images/attachments.jpg\')\"><h1>Anexos</h1></div><div class=page-content><ol><li class=file-preview ng-repeat=\"file in vm.proposal.$files\"><a target=_blank href=\"{{::file.path | mediaUrl}}\"><span class=id>{{::$index + 1}}</span> <span class=filename>{{::file.name}}</span> <span class=fileurl>{{::file.path | mediaUrl}}</span></a></li></ol></div></div></md-content><style>body {\n        background-color: #F9F9F9 !important;\n    }\n\n    #viewport {\n        background: transparent;\n    }</style>");
$templateCache.put("app/notfound/views/notfound.html","<h1>Page Not found</h1>");}]);